import React from 'react';
import Wrapper from './StyledPage';

export const Reporting = () => {
  return <Wrapper>Reporting</Wrapper>;
};
